define('models/calendar/nutrition/nutrient',[
    'underscore', 'backbone', 'utils',
], function(_, Backbone, U) {

    var OK = 'ok',
        WARNING = 'warning',
        DANGER = 'danger';

    var MNutrient = Backbone.Model.extend({
        idAttribute: 'nutrient',
        defaults: {
            max: null,
            name: "",
            nutrient: "",
            recommended: null,
            trName: "",
            unit: "",
            value: 0,
            weight: 1,
            macro: false
        },

        getValue: function() {
            return Math.abs(this.get('value'));
        },
        setValue: function(value, options) {
            return this.set('value', value, options);
        },

        setRelativeValue: function(value, options) {
            value = this.getValue() + value;
            if (value < 0) value = 0;
            return this.set('value', value, options);
        },

        isMacro: function() {
            return Boolean(this.get('macro'));
        },

        getWeight: function() {
            return this.get('weight');
        },

        getWeightedValue: function() {
            return this.getValue() * this.getWeight();
        },

        isExcessive: function() {
            var max = this.get('max');
            return max !== null && this.getValue() > max;
        },

        getPercent: function(macroTotal) {
            var recommended = this.isMacro() ? macroTotal || 1 : this.get('recommended');
            return this.getWeightedValue() / recommended * 100;
        },
        getStatus: function() {
            if (this.get('macro')) {
                return OK;
            }

            if (this.isExcessive()) return DANGER;
            if (!this.isMacro() && this.getPercent() < 80) return WARNING;
            return OK;
        },
    });

    return MNutrient;
});

